
import chatMessage from './chatMessage/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('key', {
  chatMessage
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/emojis/reducer.js
 **/